import { render, staticRenderFns } from "./BusinessLinked.vue?vue&type=template&id=2a180f4f&scoped=true&"
import script from "./BusinessLinked.vue?vue&type=script&lang=js&"
export * from "./BusinessLinked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a180f4f",
  null
  
)

export default component.exports